import { defineStore } from 'pinia';
import { storage } from '@/utils/storage';
import { router } from '@/router';
// import { useReddotStore } from '@/store';
import { getUserInfo, modifyLoginPwd, logout } from '@/api';
  
export const useUserStore = defineStore('user', {
  // persist: true,
  state: () => {
    return {
      uid: 0, // 用户ID
      nickname: '',  // 昵称
      phone: '', // 手机号
      avatar: '',
      followers: 0, // 粉丝数
      following: 0, // 关注数
      overallLike: 0, // 总点赞数
      todayLike: 0, // 今日点赞数
    }
  },
  getters: {},
  actions: {
    setAvatar(avatar) {
      this.avatar = avatar
    },
    clearData() {
      this.$reset()
      storage.remove('userInfo')
    },
    logout() {
      logout().then(()=> {}) 
      setTimeout(() => {
        storage.remove('lastNoticeDate'); //清除弹框标志缓存
        this.clearData(); //清除用户数据
        // useReddotStore().$reset();// 清空红点数量
        router.replace({ name: 'login' })
      }, 100);
    },
    setLoginInit(loginInit) {
      this.loginInit = loginInit;
    },
    setUserInfo(userData) {
      storage.set('userInfo', userData)
      this.uid = userData.uid;
      this.phone = userData.phone;
      this.nickname = userData.nickname;
      this.avatar = userData.avatar || '';
      this.followers = userData.followers;
      this.following = userData.following;
      this.overallLike = userData.overallLike;
      this.todayLike = userData.todayLike;
    },
    loadUserInfo(callback, errorCallback) {
      getUserInfo().then((res) => {
        let userData = res.data || {}
        this.setUserInfo(userData);
        callback && callback(userData);
      }, () => {
        errorCallback && errorCallback();
      })
    },
    updateLoginPwd(data, callback) {
      modifyLoginPwd(data).then((res) => {
        callback && callback();
      })
    },
  }
})
